/* eslint-disable */
import React, { useEffect, useState } from "react";
import "./styles.scss";
import { useTranslation } from "react-i18next";
import { Squash } from "hamburger-react";
import { Link } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import arrowDown from "../../assets/icon/arrowDown.svg";
import axiosInstance from "api/axiosService";

function Header() {
  const { t, i18n } = useTranslation();
  const [isOpen, setOpen] = useState(false);
  const navigate = useNavigate();
  const [language, setCurrentLanguage] = useState("vi");
  const [settingInfo, setSettingInfo] = useState({});
  const [projectDetail, setProjectDetail] = useState([]);
  const [langIsOpen, setLangIsOpen] = useState(false);
  const location = useLocation();
  const [openMenuIndex, setOpenMenuIndex] = useState(null);

  const toggleLanguage = (newLanguage) => {
    setCurrentLanguage(newLanguage);
    changeLanguage(newLanguage);
    setLangIsOpen(false);
  };

  const languages = [
    {
      code: "vi",
      name: "Tiếng Việt",
      flag: "🇻🇳",
      shortName: "VI",
    },
    {
      code: "en",
      name: "English",
      flag: "🇺🇸",
      shortName: "ENG",
    },
  ];

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  useEffect(() => {
    fetchData();
    fetchProjectData();

    // Cleanup event listeners on component unmount
    return () => {
      document
        .querySelectorAll(".parent-item .parent-title")
        .forEach((item) => {
          item.removeEventListener("hover", () => {});
        });
    };
  }, []);

  const fetchData = async () => {
    try {
      const response = await axiosInstance.get("/api/setting/info");
      setSettingInfo(response.data.data);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  const fetchProjectData = async () => {
    try {
      const projectList = await axiosInstance.get(`api/project/list`);
      const info = projectList.data.data;
      setProjectDetail(info);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  const menuItems = [
    {
      label: t("HOME"),
      path: "/",
    },
    {
      label: t("ABOUT_SSL"),
      subItems: [
        { label: t("INTRODUCTION"), path: "/introduction" },
        { label: t("SSL_NETWORK"), path: "/ssl-network" },
        { label: t("SSL_JOURNEY"), path: "/ssl-journey" },
        { label: t("CONTACT"), path: "/contact" },
      ],
    },
    {
      label: t("ARTISTS"),
      path: "/artists",
    },
    {
      label: t("NEWS"),
      path: "/ssl-news",
    },
    {
      label: t("CREW"),
      subItems: [
        { label: t("SSL_CULTURE"), path: "/ssl-culture" },
        // { label: t("SSL_CARREER"), path: "/ssl-carreer" },
        // { label: t("SSL_MAGAZINE"), path: "/ssl-magazine" },
      ],
    },
    // {
    //   label: t("merchandise.title"),
    //   path: "/merchandise",
    // },
  ];

  const normalizePath = (path) => {
    if (!path) return "";
    return path.length > 1 && path.endsWith("/") ? path.slice(0, -1) : path;
  };

  const isPathActive = (path) => {
    const current = normalizePath(location.pathname);
    const target = normalizePath(path);

    if (!target) return false;
    if (target === "/") return current === "/";
    return current === target || current.startsWith(`${target}/`);
  };

  const isActive = (item) => {
    if (item.subItems) {
      return item.subItems.some((sub) => isPathActive(sub.path));
    }
    return isPathActive(item.path);
  };

  const isActiveParent = (item) => {
    if (item.path && isPathActive(item.path)) return true;
    if (item.subItems) {
      return item.subItems.some((sub) => isPathActive(sub.path));
    }
    return false;
  };

  const goHome = () => {
    navigate("/");
  };

  return (
    <div className="header-app">
      <img
        className="logo"
        src="https://spacespeaker.s3.ap-southeast-1.amazonaws.com/uploads/SPACESPEAKERS_Logo-1741878492422.png"
        onClick={goHome}
        alt="Space Speakers Logo"
      />
      <div
        className="header-actions"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* <div
          className="language-toggle"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 10,
            cursor: "pointer",
          }}
          onMouseEnter={() => {
            setLangIsOpen(true);
            setOpen(false);
          }}
        >
          <span className="text-white current-language">
            {languages.map((lan) => {
              if (i18n.language == lan.code) return <p>{lan.shortName}</p>;
            })}
          </span>
          <img src={arrowDown} />
        </div> */}

        {/* language menu */}
        <div
          className={`
            absolute top-full right-2 mt-1 w-full bg-white border-2 border-gray-300 shadow-lg z-10 overflow-hidden
            transition-all duration-200 origin-top language-menu
            ${
              langIsOpen
                ? "opacity-100 transform scale-y-100 visible"
                : "opacity-0 transform scale-y-0 invisible"
            }
          `}
          onMouseLeave={() => setLangIsOpen(false)}
        >
          {languages.map((language) => (
            <div
              key={language.code}
              onClick={() => changeLanguage(language.code)}
              className={`
                  flex items-center space-x-2 px-4 py-3 cursor-pointer transition-colors duration-150
                  ${
                    language === language.code
                      ? "bg-blue-50 text-blue-700"
                      : "hover:bg-gray-50 text-gray-800"
                  }
                `}
            >
              <span className="font-medium flex-1">{language.name}</span>
              <span className="text-sm text-gray-500">
                {language.shortName}
              </span>
              {language === language.code && (
                <svg
                  className="w-4 h-4 text-blue-600"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              )}
            </div>
          ))}
        </div>
        <div className="btn-menu">
          <div
            className="p-2 rounded-md cursor-pointer"
            onMouseEnter={() => {
              setOpen(true);
              setLangIsOpen(false);
            }}
          >
            {/* Using the Squash component as provided */}
            <Squash toggled={isOpen} toggle={setOpen} color="#fff" size={30} />
          </div>
        </div>
      </div>

      {/* Navigation Menuu */}
      <div
        className={`menu-header ${isOpen ? "show-menu" : ""}`}
        onMouseLeave={() => setOpen(false)}
      >
        <div className="list-menu">
          {menuItems.map((item, idx) => {
            const isActiveParentItem = isActiveParent(item);
            const isOpenSubMenu =
              openMenuIndex === idx ||
              (item.subItems &&
                item.subItems.some((sub) => isPathActive(sub.path)));

            return item.subItems ? (
              <div
                key={idx}
                className={`menu-item parent-item ${
                  isActive(item) ? "active" : ""
                } ${isOpenSubMenu ? "has-active" : ""}`}
                onMouseEnter={() => {
                  if (window.innerWidth > 991) setOpenMenuIndex(idx);
                }}
                onMouseLeave={() => {
                  if (window.innerWidth > 991 && !isActive(item))
                    setOpenMenuIndex(null);
                }}
              >
                <div
                  className={`parent-title ${isActiveParentItem ? "active" : ""}`}
                  onClick={() => {
                    if (window.innerWidth <= 991) {
                      setOpenMenuIndex(openMenuIndex === idx ? null : idx);
                    }
                    if (item.path) {
                      navigate(item.path);
                    }
                  }}
                  style={{ cursor: "pointer" }}
                >
                  {item.path ? (
                    <Link to={item.path}>
                      <span>{item.label}</span>
                    </Link>
                  ) : (
                    <span>{item.label}</span>
                  )}
                </div>

                <div className="sub-menu">
                  {item.subItems.map((sub, subIdx) => (
                    <Link
                      key={subIdx}
                      to={sub.path}
                      className={`sub-item ${
                        isPathActive(sub.path) ? "active" : ""
                      }`}
                      onClick={() => {
                        setOpen(false);
                        setOpenMenuIndex(null);
                        navigate(sub.path);
                      }}
                    >
                      {sub.label}
                    </Link>
                  ))}
                </div>
              </div>
            ) : (
              <Link
                key={idx}
                to={item.path}
                className={`menu-item ${
                  isActive(item) ? "active has-active" : ""
                }`}
                onClick={() => setOpen(false)}
              >
                {item.label}
              </Link>
            );
          })}

          <div className="social-links">
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-facebook-f"></i>
            </a>
            <a
              href="https://youtube.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-youtube"></i>
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-instagram"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
